import { inject, InjectionToken } from '@angular/core';
import {
  CompanyToContactAssociationsCardComponent,
  ContactToCompanyAssociationsCardComponent,
  CrmDependencies,
  FormDefaultInputValue,
  ProfileCard,
  StandardIds,
} from '@galaxy/crm/static';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../core/auth/auth.service';
import { PARTNER_ID } from '../../tokens';
import { CRMUserService } from './user.service';

export const CrmInjectionToken = new InjectionToken<CrmDependencies>('dependencies given to crm library', {
  factory: () => {
    const authService = inject(AuthService);
    const partnerId$ = inject(PARTNER_ID);
    const userService = inject(CRMUserService);

    return {
      appID: 'vendor-center-client',
      routePrefix$: of('/crm'),
      namespace$: partnerId$,
      parentNamespace$: of(''),
      viewProfileFlag$: of(true),
      currentUserId$: authService.currentUser$.pipe(map((user) => user.userId)),
      contact: {
        profileCards$: of([{ component: ContactToCompanyAssociationsCardComponent }] as ProfileCard[]),
        formDefaultOnCreateInputValues$: of([
          { fieldId: StandardIds.ContactSourceName, value: 'CRM UI' },
          { fieldId: StandardIds.ContactRecordSourceDrill1, value: window.location.href },
          { fieldId: StandardIds.ContactOriginalSource, value: 'CRM UI' },
          { fieldId: StandardIds.ContactOriginalSourceDrill1, value: window.location.href },
        ] as FormDefaultInputValue[]),
      },
      company: {
        profileCards$: of([{ component: CompanyToContactAssociationsCardComponent }] as ProfileCard[]),
        filterInputOverrides$: of([]),
        tableCustomCells: [],
        formDefaultOnCreateInputValues$: of([
          { fieldId: StandardIds.CompanySourceName, value: 'CRM UI' },
          { fieldId: StandardIds.CompanyRecordSourceDrill1, value: window.location.href },
          { fieldId: StandardIds.CompanyOriginalSource, value: 'CRM UI' },
          { fieldId: StandardIds.CompanyOriginalSourceDrill1, value: window.location.href },
        ] as FormDefaultInputValue[]),
      },
      services: {
        userService,
      },
    } as CrmDependencies;
  },
});
